import { apiFetch } from '../apiFetch'

export const putTrivia = async (id, count = 5) => {
  return await apiFetch({
    path: '/trivia',
    method: 'PUT',
    payload: {
      id,
      count
    }
  })
}
